import { BASE_PATH } from '@/consts/environmental';
import { urls } from '@/utils/urls';

import { type FlowExecutionContext } from '../contexts/flowContext';

const joinUrl = (...parts: (string | undefined)[]) =>
  parts.filter(Boolean).join('/').replace(/\/+/g, '/');

export type UrlType = 'absoluteUrl' | 'nextJsPath' | 'absolutePath';

export const createFlowUrl = ({
  context,
  type = 'absoluteUrl',
  route,
}: {
  context: FlowExecutionContext;
  type?: UrlType;
  /** Can be a slug to get a step's URL. When not provided, just the base route is returned. */
  route?: string;
}) => {
  const { brand, baseRoute } = context;

  switch (type) {
    case 'absoluteUrl':
      return new URL(
        joinUrl(BASE_PATH, baseRoute, route),
        urls[brand].base,
      ).toString();
    case 'nextJsPath':
      return joinUrl(baseRoute, route);
    case 'absolutePath':
      return joinUrl(BASE_PATH, baseRoute, route);
  }
};

// Used so frequently that it's convenient to have a helper function for it.
export const createCurrentStepUrl = (context: FlowExecutionContext) =>
  createFlowUrl({ context, route: context.currentStepRoute });
